import { render, staticRenderFns } from "./BFormProject.vue?vue&type=template&id=2aaf4323&scoped=true&"
import script from "./BFormProject.vue?vue&type=script&lang=js&"
export * from "./BFormProject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf4323",
  null
  
)

export default component.exports